import React, { useState } from 'react';
import { Check, Shield, Zap, Lock, Gift, BookOpen } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
import { CountdownTimer } from './CountdownTimer';
import { BonusModal } from './BonusModal';
export function ValueStack() {
  const [selectedBonus, setSelectedBonus] = useState<any>(null);
  const included = [{
    name: 'Sistema completo de 7 días paso a paso',
    value: '$120.000'
  }, {
    name: 'Ventanas de sueño por edad',
    value: '$45.000'
  }, {
    name: 'Bloqueo sonoro estratégico para Colombia',
    value: '$35.000'
  }, {
    name: 'Ritual nocturno de 15 minutos',
    value: '$25.000'
  }, {
    name: 'Crisis comunes y cómo resolverlas',
    value: '$30.000'
  }];
  const bonuses = [{
    title: 'Kit Noche Blindada',
    subtitle: 'Setup Anti-Ruido en 10 Min',
    image: 'https://cdn.magicpatterns.com/uploads/anNqFT7kTfJ2LbxSrP3dvM/portada_bono_1.png',
    details: ['Mapa de Ruido', 'Setup en 10 min', 'Checklist', 'Plan B'],
    footer: 'Para ciudades ruidosas.'
  }, {
    title: 'Paz en Pareja',
    subtitle: 'Turnos Sin Pelea',
    image: 'https://cdn.magicpatterns.com/uploads/fbsPBFmS4n8uKR65zAxxin/portada_bono_2.png',
    details: ['Guión 7 min', 'Plantillas', 'Scripts', 'Protocolo'],
    footer: 'Para la relación.'
  }, {
    title: 'SOS 3:15 AM',
    subtitle: 'Tarjetas de Decisión Rápida',
    image: 'https://cdn.magicpatterns.com/uploads/fsdM1qDVButRK2iLpvi8aH/portada_bono_3.png',
    details: ['Árbol decisión', 'Tarjetas', 'Tracker', 'Casos'],
    footer: 'Para las 3 AM.'
  }];
  return <section id="oferta" className="py-12 md:py-16 bg-warm-200" data-id="element-313">
      <div className="max-w-3xl mx-auto px-4" data-id="element-314">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-primary-100" data-id="element-315">
          {/* Header */}
          <div className="bg-gradient-to-r from-primary-600 to-primary-500 py-6 px-6 text-center" data-id="element-316">
            <span className="inline-block bg-white/20 text-white rounded-full px-3 py-1 text-xs font-medium mb-3" data-id="element-317">
              🎁 Oferta Especial
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-318">
              Todo lo que recibes hoy
            </h2>
          </div>

          <div className="p-6 md:p-8" data-id="element-319">
            {/* Included Items */}
            <div className="mb-8" data-id="element-320">
              <div className="flex items-center gap-3 mb-4" data-id="element-321">
                <div className="h-px bg-warm-200 flex-1" data-id="element-322"></div>
                <div className="flex items-center gap-1.5 text-primary-600" data-id="element-323">
                  <BookOpen className="w-4 h-4" data-id="element-324" />
                  <span className="uppercase tracking-wider text-xs font-semibold" data-id="element-325">
                    Dentro del Ebook
                  </span>
                </div>
                <div className="h-px bg-warm-200 flex-1" data-id="element-326"></div>
              </div>
              <p className="text-sm text-text-muted text-center mb-4" data-id="element-327">
                Un solo manual digital con todo lo que necesitás:
              </p>
              <ul className="space-y-3" data-id="element-328">
                {included.map((item, i) => <li key={i} className="flex items-center justify-between" data-id="element-329">
                    <div className="flex items-center gap-3" data-id="element-330">
                      <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-331" />
                      <span className="text-sm md:text-base text-text-body font-medium" data-id="element-332">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-sm text-text-muted line-through ml-4 shrink-0" data-id="element-333">
                      {item.value}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Bonuses */}
            <div className="mb-8" data-id="element-334">
              <div className="flex items-center gap-3 mb-5" data-id="element-335">
                <div className="h-px bg-warm-200 flex-1" data-id="element-336"></div>
                <div className="flex items-center gap-1.5 text-gold-500" data-id="element-337">
                  <Gift className="w-4 h-4" data-id="element-338" />
                  <span className="uppercase tracking-wider text-xs font-bold" data-id="element-339">
                    + 3 Bonos de Acción Rápida
                  </span>
                </div>
                <div className="h-px bg-warm-200 flex-1" data-id="element-340"></div>
              </div>

              <div className="space-y-3" data-id="element-341">
                {bonuses.map((bonus, i) => <button key={i} onClick={() => setSelectedBonus(bonus)} className="w-full bg-warm-50 hover:bg-warm-100 transition-colors rounded-xl p-3 flex items-center gap-4 text-left border border-transparent hover:border-warm-200" data-id="element-342">
                    <div className="w-20 h-20 bg-gradient-to-br from-primary-700 to-primary-600 rounded-lg p-1.5 shrink-0 flex items-center justify-center" data-id="element-343">
                      <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-md" data-id="element-344" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-345">
                      <h4 className="font-semibold text-text-dark text-sm md:text-base truncate" data-id="element-346">
                        {bonus.title}
                      </h4>
                      <p className="text-xs md:text-sm text-text-muted truncate mt-0.5" data-id="element-347">
                        {bonus.subtitle}
                      </p>
                    </div>
                    <span className="text-sm text-primary-600 font-medium whitespace-nowrap hidden sm:block" data-id="element-348">
                      Leer más...
                    </span>
                  </button>)}
              </div>
            </div>

            {/* Price */}
            <div className="bg-gradient-to-br from-warm-50 to-warm-100 rounded-2xl p-6 md:p-8 text-center mb-6 border border-warm-200" data-id="element-349">
              <p className="text-sm font-medium text-text-muted uppercase tracking-wide mb-2" data-id="element-350">
                Precio especial
              </p>
              <div className="flex items-baseline justify-center gap-1.5 mb-2" data-id="element-351">
                <span className="text-5xl md:text-6xl font-bold text-primary-600" data-id="element-352">
                  $29.999
                </span>
                <span className="text-xl text-primary-600 font-medium" data-id="element-353">
                  COP
                </span>
              </div>
              <p className="text-sm text-text-muted mb-6" data-id="element-354">
                Menos que un domicilio para dos
              </p>

              <div className="flex flex-col items-center gap-3 mb-6" data-id="element-355">
                <p className="text-xs font-bold text-red-500 uppercase tracking-wider" data-id="element-356">
                  Oferta por tiempo limitado
                </p>
                <CountdownTimer data-id="element-357" />
              </div>

              <HolographicButton href="https://emalia.lat/cart/48344374509818:1" size="lg" className="w-full md:w-4/5 mx-auto" id="btn-compra-principal" data-id="element-358">
                Comprar ahora
              </HolographicButton>
            </div>

            {/* Trust */}
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-text-body font-medium mb-6" data-id="element-359">
              <div className="flex items-center gap-1.5" data-id="element-360">
                <Zap className="w-4 h-4 text-primary-500" data-id="element-361" /> Entrega inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-362">
                <Lock className="w-4 h-4 text-primary-500" data-id="element-363" /> Acceso de por vida
              </div>
              <div className="flex items-center gap-1.5" data-id="element-364">
                <Shield className="w-4 h-4 text-primary-500" data-id="element-365" /> Garantía 7 días
              </div>
            </div>

            {/* Payment Logos */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6 border-t border-warm-200" data-id="element-366">
              <span className="text-xs text-text-muted font-medium" data-id="element-367">
                Pago seguro:
              </span>
              <div className="flex items-center gap-4" data-id="element-368">
                <img src="https://cdn.magicpatterns.com/uploads/2g7JUoGT4Y31KBDxHq4Rp2/Visa_logo.png" alt="Visa" className="h-5 object-contain opacity-80" data-id="element-369" />
                <img src="https://cdn.magicpatterns.com/uploads/j38mwo8M7pUiFefXPbFuZH/Mastercard_logo.png" alt="Mastercard" className="h-5 object-contain opacity-80" data-id="element-370" />
                <img src="https://cdn.magicpatterns.com/uploads/1zV5ps1ooTUwFyijhJQzug/Nequi_logo.png" alt="Nequi" className="h-4 object-contain opacity-80" data-id="element-371" />
                <img src="https://cdn.magicpatterns.com/uploads/oDaghU1m2dq4gvgie76GD1/efecty-logo.png" alt="Efecty" className="h-4 object-contain opacity-80" data-id="element-372" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <BonusModal isOpen={!!selectedBonus} onClose={() => setSelectedBonus(null)} bonus={selectedBonus} data-id="element-373" />
    </section>;
}